import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../enter/enter";
import Display from "../display/display";
const DaweManage = ({ userData }) => {
  const [key, setKey] = useState("enter");
  const [Datee, setDatee] = useState("");
  const [Namemowakell, setNamemowakell] = useState([]);
  const [Sefamo, setSefamo] = useState("");
  const [NameKhesm, setNameKhesm] = useState([]);
  const [SefaKhesm, setSefaKhesm] = useState("");
  const [TypeDawa, setTypeDawa] = useState("");
  const [NumberDawa, setNumberDawa] = useState("");
  const [DawaId, setDawaId] = useState("");
  const [Year, setYear] = useState("");
  const [Mawdodawa, setMawdodawa] = useState("");
  const [TakadyDegree, setTakadyDegree] = useState("");
  const [Mahkamaa, setMahkama] = useState("");
  const [Numbercircle, setNumbercircle] = useState("");
  const [Typecircle, setTypecircle] = useState("");
  const [SummaryDawa, setSummaryDawa] = useState("");
  const [Nots, setNots] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [NoteImg, setNoteImg] = useState("");
  const [DawaEnded, setDawaEnded] = useState(false);
  const [Eye, setEye] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة الدعاوي</h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title="بيانات الدعوى">
                <Enter
                  Eye={Eye}
                  setEye={setEye}
                  setIsEdit={setIsEdit}
                  isEdit={isEdit}
                  userData={userData}
                  setDawaEnded={setDawaEnded}
                  DawaEnded={DawaEnded}
                  setDawaId={setDawaId}
                  DawaId={DawaId}
                  NoteImg={NoteImg}
                  setNoteImg={setNoteImg}
                  Datee={Datee}
                  setDatee={setDatee}
                  Namemowakell={Namemowakell}
                  setNamemowakell={setNamemowakell}
                  Sefamo={Sefamo}
                  setSefamo={setSefamo}
                  NameKhesm={NameKhesm}
                  setNameKhesm={setNameKhesm}
                  SefaKhesm={SefaKhesm}
                  setSefaKhesm={setSefaKhesm}
                  TypeDawa={TypeDawa}
                  setTypeDawa={setTypeDawa}
                  NumberDawa={NumberDawa}
                  setNumberDawa={setNumberDawa}
                  Year={Year}
                  setYear={setYear}
                  Mawdodawa={Mawdodawa}
                  setMawdodawa={setMawdodawa}
                  TakadyDegree={TakadyDegree}
                  setTakadyDegree={setTakadyDegree}
                  Mahkamaa={Mahkamaa}
                  setMahkama={setMahkama}
                  Numbercircle={Numbercircle}
                  setNumbercircle={setNumbercircle}
                  Typecircle={Typecircle}
                  setTypecircle={setTypecircle}
                  SummaryDawa={SummaryDawa}
                  setSummaryDawa={setSummaryDawa}
                  Nots={Nots}
                  setNots={setNots}
                  setSelectedFile={setSelectedFile}
                  selectedFile={selectedFile}
                />
              </Tab>
              {/* <Tab eventKey="money" title="اضافة عمل اداري">
                <Money />
              </Tab> */}
              <Tab eventKey="display" title="عرض">
                <Display
                  Eye={Eye}
                  setEye={setEye}
                  setIsEdit={setIsEdit}
                  isEdit={isEdit}
                  setDawaEnded={setDawaEnded}
                  DawaEnded={DawaEnded}
                  setKey={setKey}
                  key={key}
                  setDawaId={setDawaId}
                  DawaId={DawaId}
                  NoteImg={NoteImg}
                  setNoteImg={setNoteImg}
                  Datee={Datee}
                  setDatee={setDatee}
                  Namemowakell={Namemowakell}
                  setNamemowakell={setNamemowakell}
                  Sefamo={Sefamo}
                  setSefamo={setSefamo}
                  NameKhesm={NameKhesm}
                  setNameKhesm={setNameKhesm}
                  SefaKhesm={SefaKhesm}
                  setSefaKhesm={setSefaKhesm}
                  TypeDawa={TypeDawa}
                  setTypeDawa={setTypeDawa}
                  NumberDawa={NumberDawa}
                  setNumberDawa={setNumberDawa}
                  Year={Year}
                  setYear={setYear}
                  Mawdodawa={Mawdodawa}
                  setMawdodawa={setMawdodawa}
                  TakadyDegree={TakadyDegree}
                  setTakadyDegree={setTakadyDegree}
                  Mahkamaa={Mahkamaa}
                  setMahkama={setMahkama}
                  Numbercircle={Numbercircle}
                  setNumbercircle={setNumbercircle}
                  Typecircle={Typecircle}
                  setTypecircle={setTypecircle}
                  SummaryDawa={SummaryDawa}
                  setSummaryDawa={setSummaryDawa}
                  Nots={Nots}
                  setNots={setNots}
                  setSelectedFile={setSelectedFile}
                  selectedFile={selectedFile}
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default DaweManage;
